import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'h-[700px] w-full'
  }
});
